module.exports = __webpack_public_path__ + "img/QR-5999.c331dc84.png";